module.exports = [
  'transaction_fee',
  'exchange_spread',
  'exchange_spread_sc',
  'min_tx_fee',
  'referral_fee',
  'fixed_fee_lunu',
  'fixed_fee_referral',
  'tax',
  // 'rolling_reserve'
];
